/**
 * @module components/marketing/BackedBy
 * @description "Backed by LvlUp Labs, Amazon, Google, and NVIDIA" logo strip.
 *
 * @extracted-from client/src/App.js (lines ~2190-2216)
 */

import React from 'react';

const PROGRAMS = [
  { href: 'https://lvlup.vc/labs', src: '/lvlup_labs_logo.png', alt: 'LvlUp Labs' },
  { href: 'https://aws.amazon.com/activate/', src: '/aws.jpeg', alt: 'AWS Activate' },
  { href: 'https://startup.google.com/', src: '/google.jpg', alt: 'Google for Startups' },
  { href: 'https://www.nvidia.com/en-us/startups/', src: '/nvidia.png', alt: 'NVIDIA Inception' },
];

const BackedBy = () => {
  return (
    <div className="mt-16 md:mt-20 text-center border-t border-white/[0.06] pt-12">
      <p className="font-display text-base md:text-lg text-critic-text-secondary font-normal leading-relaxed mb-6 max-w-xl mx-auto px-2">
        Backed by LvlUp Labs, Amazon, Google, and NVIDIA.
      </p>
      <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
        {PROGRAMS.map((program) => (
          <a
            key={program.alt}
            href={program.href}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex h-20 w-36 md:h-24 md:w-44 items-center justify-center rounded-2xl bg-white px-4 py-3 border border-white/[0.08] shadow-[0_20px_60px_rgba(0,0,0,0.35)] transition-all duration-300 hover:scale-[1.02] hover:shadow-[0_24px_72px_rgba(0,0,0,0.4)]"
          >
            <img
              src={program.src}
              alt={program.alt}
              className="h-10 w-full md:h-12 object-contain"
            />
          </a>
        ))}
      </div>
    </div>
  );
};

export default BackedBy;
